import { tap, map, catchError } from 'rxjs/operators';
import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { DataService } from './../../../core/service/base/data.service';

import { APP_CONFIG, IAppConfig } from './../../../app.config';
import { Mail } from './../../model/mail';
import { MailFilter } from '../../model/mail-filter';
import { PagedFilter } from '../../../core/model/paged-filter';
import { Observable } from 'rxjs';
import { ProgressBarService } from '../../../core/service/progress-bar.service';
import { MessageService } from '../../../core/service/message.service';

@Injectable()
export class MailService extends DataService<Mail> {
  private readonly _defaultFilterFields: string[] = ['status', 'createdDateTime'];

  constructor(
    httpClient: HttpClient,
    @Inject(APP_CONFIG) config: IAppConfig,
    messageService: MessageService,
    progressBar: ProgressBarService
  ) {
    super(httpClient, config, messageService, Mail, progressBar, 'mail');
  }

  getFilterDefinition(): Observable<PagedFilter<MailFilter>> {
    return this.client.get<PagedFilter<MailFilter>>(`${this.endpoint}/filter`).pipe(
      map(res => {
        const result = res;
        result.filter.defaultFields = this._defaultFilterFields;
        if (!result.filter.selectedFields || result.filter.selectedFields.length === 0) {
          result.filter.selectedFields = this._defaultFilterFields;
        }

        result.filter.status = Number.isInteger(result.filter.status) ? result.filter.status.toString() : '';
        return result;
      }),
      catchError(error => {
        console.log(error);
        return [];
      })
    );
  }

  createLeaseAgreementMails(data: any): Observable<any> {
    return this.client.post(`${this.endpoint}/create/lease-agreement`, JSON.stringify(data));
  }

  getMailDefaults(): Observable<any> {
    return this.client.get(this.endpoint + '/new');
  }

  preview(id: string): Observable<any> {
    return this.getPdf(`preview/${id}`);
  }

  previewTenatMails(contractIds: any): Observable<Blob> {
    return this.client.post(`${this.endpoint}/preview/tenant-mail`, JSON.stringify(contractIds), { responseType: 'blob' }).pipe(
      catchError(error => {
        this.notification.showError(error);
        return null;
      }),
      map((res: any) => {
        if (res) {
          return new Blob([res as BlobPart], { type: 'application/pdf' });
        }
      })
    );
  }

  previewNew(mail: Mail): Observable<any> {
    return this.client.post(`${this.endpoint}/preview`, JSON.stringify(mail), { responseType: 'blob' });
  }

  send(id: string): Observable<any> {
    return this.client
      .put(`${this.endpoint}/send`, {}, { params: new HttpParams().append('id', id) })
      .pipe(tap(() => this.notification.showSuccess('SUCCESS.LETTER_SENT')));
  }

  sendNew(mail: any): Observable<any> {
    return this.client.put(`${this.endpoint}/send`, JSON.stringify(mail));
  }

  sendToTenants(mail: any): Observable<any> {
    return this.client.post(`${this.endpoint}/send/tenant-mail`, JSON.stringify(mail));
  }

  sendLetterFiltered(filter: any, includedIds: string[], excludedIds: string[], affectedItemsCount: number): Observable<any> {
    return this.client
      .put(`${this.endpoint}/send-letter-filter`, {
        filter: this.prepareFilter(filter),
        includedIds: includedIds,
        excludedIds: excludedIds,
        affectedItemsCount: affectedItemsCount,
      })
      .pipe(tap(() => this.notification.showSuccess('SUCCESS.LETTER_SENT')));
  }
}
